export const ROLES = Object.freeze({
  CANVASSER: "ROLE_CANVASSER",
  ACCOUNT_MANAGER: "ROLE_ACCOUNT_MANAGER",
  REGIONAL_MANAGER: "ROLE_REGIONAL_MANAGER",
  SUPER_ADMIN: "ROLE_SUPER_ADMIN",
});

export const getStoredRole = () => localStorage.getItem("userRole");

export const getStoredIsSuperAdmin = () =>
  localStorage.getItem("isSuperAdmin") === "true";

export const isRegionalManager = () =>
  getStoredRole() === ROLES.REGIONAL_MANAGER && !getStoredIsSuperAdmin();
